import { render, staticRenderFns } from "./Switche.vue?vue&type=template&id=b4e1a9e0&scoped=true"
import script from "./Switche.vue?vue&type=script&lang=js"
export * from "./Switche.vue?vue&type=script&lang=js"
import style0 from "./Switche.vue?vue&type=style&index=0&id=b4e1a9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e1a9e0",
  null
  
)

export default component.exports